import { useConfigurationOptionsContext } from "app/providers/DoorOptionsProvider";

import ColorOptionControls from "features/option-controls/color-option-controls";
import GlassOptionControls from "features/option-controls/glass-option-controls";
import HandleOptionControls from "features/option-controls/handle-option-controls";

import KaderdeurSelfInstallment from "../../../features/option-controls/doors-self-installment/KaderdeurSelfInstallment";
import OptionTemplate from "shared/ui/option-template";
import { OptionModalState } from "widgets/configurator/option-modal";
import { ExtraOptionsBlock } from "widgets/configurator/door-options/extra-option-controls/ExtraOptionsBlock";
import DubbelKaderdeurSelfInstallment from "../../../features/option-controls/doors-self-installment/DubbelKaderdeurSelfInstallment";
import KozijnKaderdeurSelfInstallment from "../../../features/option-controls/doors-self-installment/KozijnKaderdeurSelfInstallment";
import { Delimiter } from "./Delimiter";
import { zakelijkProfielCodes } from "features/option-controls/door-width-controls/ZakelijkHelper";
import { ProfielSelector } from "./ProfielSelector";

const DOORS_WITH_ENABLED_INSTALLMENT_TOGGLE_BUSINESS_DOORS = [
  "kaderdeur",
  "dubbelekaderdeur",
  "zakelijkkozijn",
];

interface BusinessDoorOptionsProps {
  setOptionModalState: (state: OptionModalState) => void;
}
const BusinessDoorOptions = ({
  setOptionModalState,
}: BusinessDoorOptionsProps) => {
  const { handle, color, glass, selectedDoor, selfAssembleDoorData, layout } =
    useConfigurationOptionsContext();

  if (!selectedDoor) return null;

  // Title for deurbeslag section
  // It only differs for kozijn
  const handleSectionTitle =
    selectedDoor.code === "zakelijkkozijn"
      ? "Kies type slot"
      : "Kies deurbeslag";

  const isZakelijkProfielItem = zakelijkProfielCodes.includes(
    selectedDoor.code,
  );
  return (
    <>
      <Delimiter className="gg-mt-5" />
      {selfAssembleDoorData.selfAssembly &&
        DOORS_WITH_ENABLED_INSTALLMENT_TOGGLE_BUSINESS_DOORS.includes(
          selectedDoor.code,
        ) && (
          <OptionTemplate
            title="Afmeting deur"
            description="Om de afmetingen van jouw deur te kunnen bepalen hebben we de afmetingen van de deuropening nodig. Je hoeft geen rekening te houden met aftrekmaten of overlap. Die berekenen wij voor je."
            showInfo={false}
            className="!gg-pt-5"
            testId="door-self-installment-option"
          >
            {selectedDoor.code === "kaderdeur" ? (
              <KaderdeurSelfInstallment
                onShowInfoClick={({ title, description }) =>
                  setOptionModalState({
                    isOpen: true,
                    heading: title,
                    description: description,
                  })
                }
              />
            ) : selectedDoor.code === "dubbelekaderdeur" ? (
              <DubbelKaderdeurSelfInstallment
                onShowInfoClick={({ title, description }) =>
                  setOptionModalState({
                    isOpen: true,
                    heading: title,
                    description: description,
                  })
                }
              />
            ) : selectedDoor.code === "zakelijkkozijn" ? (
              <KozijnKaderdeurSelfInstallment
                onShowInfoClick={({ title, description }) =>
                  setOptionModalState({
                    isOpen: true,
                    heading: title,
                    description: description,
                  })
                }
              />
            ) : (
              <></>
            )}
          </OptionTemplate>
        )}

      <Delimiter />

      <OptionTemplate
        title="Kies jouw kleur"
        selected={color}
        testId="door-color-option"
        onShowInfoClick={() =>
          setOptionModalState({
            isOpen: true,
            heading: "Kies jouw kleur",
            description:
              "We hebben diverse kleuren geselecteerd, zodat er altijd wel een framekleur is die bij jouw interieur past! Ga jij voor klassiek zwart of wil je juist meer kleur?",
          })
        }
      >
        <ColorOptionControls />
      </OptionTemplate>

      {isZakelijkProfielItem && (
        <OptionTemplate
          title="Beschikbare profielen"
          selected={layout}
          testId="door-profiel-option"
          showInfo={false}
        >
          <ProfielSelector />
        </OptionTemplate>
      )}

      {selectedDoor?.code !== "zakelijkkozijn" && !isZakelijkProfielItem && (
        <OptionTemplate
          title="Kies soort glas"
          testId="door-glass-option"
          onShowInfoClick={() =>
            setOptionModalState({
              isOpen: true,
              heading: "Kies soort glas",
              description:
                "Meer licht in de woonkamer of juist 100% privacy op het toilet? Ontdek onze glassoorten en " +
                "creëer het mooiste effect.",
            })
          }
          selected={glass}
        >
          <GlassOptionControls isBusinessDoor={true} />
        </OptionTemplate>
      )}

      {selectedDoor && !isZakelijkProfielItem && (
        <OptionTemplate
          title={handleSectionTitle}
          selected={handle}
          testId="door-handle-option"
          onShowInfoClick={() =>
            setOptionModalState({
              isOpen: true,
              heading: "Kies deurbeslag",
              description:
                "Bij iedere deur is standaard deurbeslag inbegrepen. Wil je liever iets anders? " +
                "Maak dan hieronder je keuze.",
            })
          }
        >
          <HandleOptionControls />
        </OptionTemplate>
      )}

      <ExtraOptionsBlock setOptionModalState={setOptionModalState} />
    </>
  );
};
export default BusinessDoorOptions;
